<template>
  <el-menu :default-active="active" class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose" :collapse="collapse" text-color="#666666" :unique-opened="true" router :collapse-transition="false">
    <sidebar-item v-for="menu in menuList" :key="menu.path" :item="menu" />
  </el-menu>
</template>
<script>
import SidebarItem from "./SidebarItem";
import StringTool from "@/utils/stringTool";
export default {
  name: "Sidebar",
  components: { SidebarItem },
  props: {
    menuList: {
      type: Array,
      required: true,
    },
    collapse: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      active: "",
    };
  },
  mounted () {
    this.active = StringTool.escapeUrlOfStr(this.$route.fullPath);
  },
  methods: {
    handleOpen (key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose (key, keyPath) {
      console.log(key, keyPath);
    },
  },
  watch: {
    $route (to, from) {
      this.active = StringTool.escapeUrlOfStr(to.fullPath);
    },
  },
};
</script>
<style>
.el-menu-vertical-demo .el-menu-item .el-icon-menu + span {
  overflow: hidden\0;
  text-overflow: ellipsis\0;
  display: -webkit-box\0;
  -webkit-line-clamp: 2\0; /* 可以显示的行数，超出部分用...表示*/
  -webkit-box-orient: vertical\0;
}
</style>
<style lang="scss">
.el-menu-vertical-demo.el-menu {
  background-color: #ffffff00;
}
.el-menu-vertical-demo.el-menu.el-menu--inline {
  background-color: #ffffff00;
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
}
.el-menu-vertical-demo .el-menu-item,
.el-submenu__title {
  display: flex;
  align-items: center;
}
.el-menu-vertical-demo .el-menu-item .el-icon-menu {
  min-width: 24px\0;
}

.aside .el-menu--popup {
  background: rgb(3, 10, 30) !important;
}
.aside .el-menu-item:hover {
  color: #303133 !important;
}
.aside .el-menu-item:focus {
  outline: 0;
  background-color: #030a1e;
  color: #ffffff !important;
}
.el-menu--popup .el-submenu__title {
  color: #303133 !important;
}
.el-menu--horizontal .el-menu--popup .el-menu-item {
  color: #ffffff !important;
  font-size: 16px !important;
  background-color: #0054ab !important;
}
.el-menu--horizontal,
.el-menu {
  background-color: #0054ab !important;
}

.el-menu--horizontal .el-menu--popup .el-menu-item:hover {
  background-color: #00316d !important;
  color: #ffd04b !important;
}

.el-menu--horizontal .el-menu--popup .is-active {
  color: #ffd04b !important;
}
.el-menu--horizontal .el-submenu .el-submenu__title {
  color: #ffffff !important;
  font-size: 16px !important;
}
.el-menu--horizontal .is-active .el-submenu__title {
  color: #ffd04b !important;
}
.el-menu--horizontal .is-active .el-submenu__title i {
  color: #ffd04b !important;
}

.el-menu--horizontal .el-submenu .el-submenu__title i {
  color: #ffffff;
  font-size: 16px !important;
}

.el-menu--horizontal .el-menu--popup .el-menu-item i {
  display: none !important;
}

.el-menu--popup-right-start {
  margin: 0px !important;
  padding: 0px !important;
  background: #ffffff !important;
  box-sizing: border-box !important;
}

.el-menu--horizontal .el-submenu .el-submenu__title i {
  display: none;
}
.el-menu--horizontal .el-submenu .el-submenu__title .el-icon-arrow-right {
  display: block;
}

.el-menu--horizontal .el-submenu :hover {
  background-color: #00316d !important;
}
.el-menu--popup .el-menu-item {
  color: #303133 !important;
}

.header-top .el-submenu__title {
  font-size: 16px !important;
}
.header-top .el-submenu .el-submenu__title {
  font-size: 16px !important;
}
.header-top .menu-item .el-menu-item {
  font-size: 16px !important;
}
.header-top .el-submenu .el-submenu__title {
  font-size: 16px !important;
}
.el-menu--popup-bottom-start .menu-item {
  width: auto !important;
  flex: 0 !important;
}
.header-top .el-menu-item i {
  display: none;
}
.el-submenu__title i {
  color: #999999 !important;
}
.el-submenu__title:hover,
.el-submenu__title {
  background: none !important;
}
</style>
